<sb-card [loading]="loading">
  <div card-header>
    <b>{{'lang.companyDetails.attributesHeadline' | translate}}</b>
  </div>
  <div card-header-more>
  </div>
  <div card-body>
    <sb-comp-settings *ngIf="company" [company]="company" [heightPx]="340"></sb-comp-settings>
  </div>
</sb-card>
